<template>
  <v-text-field
    :id="id"
    v-model="getValue"
    v-mask="getMask"
    :outlined="outlined"
    :color="color"
    v-bind="$attrs"
    @blur="emit($event)"
  />
</template>

<script>
import VuetifyOverwriteMixin from './VuetifyOverwriteMixin';

export default {
  name: 'InputPhone',
  mixins: [VuetifyOverwriteMixin],
  data: (vm) => ({
    tel: vm.value,
  }),
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(value) {
        return value;
      },
    },
    getTel() {
      return String(this.getValue)
        .replace('+55', '')
        .replace(/[^0-9]+/g, '');
    },
    getMask() {
      switch (this.getTel.length) {
        case 8:
          return '####-####';
        case 9:
          return '#####-####';
        case 10:
          return '(##) ####-####';
        default:
          return '(##) #####-####';
      }
    },
    emit() {
      return (ev) => {
        const { value } = ev.target;
        this.$emit('input', value);
      };
    },
  },
};
</script>
